import styled from "styled-components";

export const Main = styled.main`
    display: block;
    flex: 1;
    width: 100%;
    min-height: calc(100% - 73px);
    width: 100%;
    float: right;
    padding: 30px;
    

    div.cor{
      box-shadow: unset;
      height: calc(100% + 6px);
      border-radius: 0;
      margin: -4px;
      width: calc(100% + 6px);
    }

    .page{
        position: relative;
        margin: 0 auto;
        background: #fff;
        width: 100%;
        box-shadow: 1px 1px 5px rgba(0,0,0,0.1);
        max-width: 1082px;
        padding: 30px;
        margin-bottom: 40px;

    }

    .spaceInfo{
        background: transparent;
        box-shadow: none;
        padding: 0;
        margin-bottom: 20px;
        display: flex;
        align-items: center;

        button{
            background: var(--verde);
            color: #fff;
            font-size: 1.1rem;
            padding: 15px 20px;
            border-radius: 10px;
            margin-right: 10px;
        }
    }



    @media(max-width: 470px){
      .page{
        padding: 10px;
      }
      .logo{
        width: 100px;
        height: auto;
      }
      .spaceInfo{
        margin-bottom: 10px;
        display: grid;
        grid-template-columns: 50% 50%;
        gap: 10px;

        button{
            font-size: 1rem;
            padding: 15px 10px;
            white-space: unset;
            width: 100%;
        }
      }
    }
    @media(max-width: 470px){
      padding: 10px;
      .spaceInfo{
        margin-bottom: 5px;
        display: grid;
        grid-template-columns: 40% 60%;
        gap: 10px;

        button{
            font-size: 0.8rem;
            padding: 10px 5px;
        }
      }
    }
`
